import { Component, OnInit, ViewChild } from '@angular/core';
import { LocalizationService } from 'src/services/localization.service';

@Component({
  standalone: false,
  selector: 'app-vertically-centered',
  templateUrl: './vertically-centered.component.html',
  styleUrls: ['./vertically-centered.component.scss']
})
export class VerticallyCenteredComponent implements OnInit {

  isCollapsed: boolean;

  constructor(public loc : LocalizationService) {
    this.isCollapsed = true;
  }

  ngOnInit() { }
}